import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "vector",
      d: "M2.08333 7.58317V2.58317C2.08333 1.6627 2.82953 0.916504 3.75 0.916504H7.44136C7.99862 0.916504 8.519 1.19501 8.82811 1.65867L9.50522 2.67434C9.81433 3.138 10.3347 3.4165 10.892 3.4165H16.25C17.1705 3.4165 17.9167 4.1627 17.9167 5.08317V12.5832C17.9167 13.5036 17.1705 14.2498 16.25 14.2498H8.75M3.75 10.0832V12.5832M3.75 12.5832V15.0832M3.75 12.5832H1.25M3.75 12.5832H6.25",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }